import { MODULE_LOGISTIQUE_TECHNIQUE } from '@/configuration/devisConf';

export default function genererOTTech() {
  return {
    dateSouhaitee: null,
    datePlanification: null,
    dateRealisation: null,
    dateFacture: null,
    typeOtId: null,
    typeOt: null,
    fournisseurId: null,
    fournisseur: null,
    montantHt: 0,
    description: null,
    tags: [],
    taches: [],
    otPatrimoine: null,
    demandesLogistique: [],
    demandesLogistiqueIds: [],
    bilanIntervention: null,
    agenceId: null,
    villes: [],
    adresse: null,
    codesPostaux: [],
    codeFacture: null,
    module: MODULE_LOGISTIQUE_TECHNIQUE,
    otStock: {
      lieuDeLivraisonId: null,
      lieuDeStockageId: null,
      quantite: null,
      produitId: null,
    },
  };
}
